// extracted by mini-css-extract-plugin
export var badge = "Teaser-module--badge--MQ5d8";
export var component = "Teaser-module--component--SiLqx";
export var content = "Teaser-module--content--HyxIt";
export var inner = "Teaser-module--inner--37LhO";
export var media = "Teaser-module--media--NJALg";
export var meta = "Teaser-module--meta--fSjMT";
export var title = "Teaser-module--title--W1IYx";